let Funds = [
  {
    Asset: "USDT",
    FullName: "Tether USD",
    Price: "10,098,36",
    Quantity: "0.2785689852",
    Holding: "10,098,36",
    Interest: "0.2785689853",
  },
  {
    Asset: "BNB",
    FullName: "Binance",
    Price: "10,098,36",
    Quantity: "0.2785689852",
    Holding: "10,098,36",
    Interest: "0.2785689852",
  },
  {
    Asset: "BTC",
    FullName: "Bitcoin",
    Price: "10,098,36",
    Quantity: "0.2785689852",
    Holding: "10,098,36",
    Interest: "0.2785689852",
  },
  {
    Asset: "ETH",
    FullName: "Ethereum",
    Price: "10,098,36",
    Quantity: "0.2785689852",
    Holding: "10,098,36",
    Interest: "0.2785689852",
  },
  {
    Asset: "BNB",
    FullName: "Binance",
    Price: "10,098,36",
    Quantity: "0.2785689852",
    Holding: "10,098,36",
    Interest: "0.2785689852",
  },
];

export default Funds;
